'use client';

import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from '@/components/ui/carousel';
import CardSlider from '../CardSlider';
import * as React from 'react';
import { TypeSameDoctors } from '../types/TypesDocsId';

export default function CarouselAboutDoctors({
    otherDoc,
    name,
}: TypeSameDoctors) {
    return (
        <div className="order-1 mt-8 lg:mt-6 p-6 bg-white rounded-2xl shadow-m size-full">
            <h3 id="sames_doctors" className="text-base font-semibold pb-3">
                {`پزشکان مشابه دکتر ${name}`}
            </h3>
            <Carousel
                // plugins={[plugin.current]}
                className="lg:pt-10"
                opts={{
                    direction: 'rtl',
                    loop: false,
                }}
            >
                <CarouselContent>
                    {otherDoc.map((doc) => (
                        <CarouselItem
                            key={doc.id}
                            className="lg:basis-1/2  sm:!basis-1/2 md:!basis-1/3"
                        >
                            <CardSlider {...doc} />
                        </CarouselItem>
                    ))}
                </CarouselContent>
                <div className="flex">
                    <CarouselPrevious className="top-[calc(50%+1.5rem)] lg:top-3 left-0 lg:left-1" />
                    <CarouselNext className="top-[calc(50%+1.5rem)] lg:top-3 right-0 lg:right-[440px]" />
                </div>
            </Carousel>
        </div>
    );
}
